import styled from "styled-components";

export const HeaderWrapper = styled.div``

export const Separator = styled.div`
    background-color: #93c5fd;
    height: 0.25rem;
    margin-top: -0.5rem;
    margin-bottom: 1rem;
`